import React, { useState, useEffect } from "react";
import { IonPage, IonContent, IonAccordion, IonItem, IonLabel, IonList, IonAccordionGroup } from '@ionic/react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import './Notifications.css';
import env from '../env.json'
import ReactGA from "react-ga4";
import axios from "axios";

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/Notifications',
//       page_title: 'Notifications'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

// ReactGA.send({ hitType: "pageview", page: "/pages/Notifications", title: "Notificaciones" });

const Notifications: React.FC = () => {

  
    const [notifications, setNotifications] = useState([{id: '', title: '', description: ''}]);

    const url = env.REACT_APP_URL;
    const token = localStorage.getItem('token');
    const header = {
        'Authorization': 'Bearer ' + token
    }

    const getNotifications = async () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/notifications')
        .then(res => {
            setNotifications(res.data.data);
        })
    }

    useEffect( () => {
        getNotifications();
    }, [])

    if(notifications[0].id == "") {
        return(
            <IonPage>
                <Header pageName="Notificaciones"/>
                <IonContent className='container'>
                    <div className="container justify-content-center no-encuestas">
                        <h3>No hay notificaciones disponibles</h3>
                    </div>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }

    else {
        return(
            <IonPage>
                <Header pageName="Notificaciones"/>
                <IonContent className='container'>
                    <IonAccordionGroup>
                        {   notifications[0].id != "" &&
                            notifications.map( notification => {
                                return (
                                    <IonAccordion key={notification.id}>
                                        <IonItem slot="header">
                                            <IonLabel >{notification.title}</IonLabel>
                                        </IonItem>
                                        <IonList slot="content" lines="inset">
                                            <IonItem>
                                                <p className="items">{notification.description}</p>
                                            </IonItem>
                                        </IonList>
                                    </IonAccordion>
                                );
                            })
                        }
                    </IonAccordionGroup>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }
}

export default Notifications;
